module.exports = __webpack_public_path__ + "static/img/mohe.ec1fd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/secondToolList/mohe.png
// module id = iqhX
// module chunks = 3